import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';
import upperFirst from 'lodash/upperFirst';

import { Tag, TagGroup, Text } from '@backstage/ui';

const useStyles = makeStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'var(--bui-space-2)',
  },
  value: {
    paddingLeft: 'var(--bui-space-2)',
  },
  newValue: {
    color: 'var(--bui-fg-success)',
  },
  oldValue: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
  smallFont: {
    fontSize: 'var(--bui-font-size-2)',
  },
});

export interface ActivityTagItemProps {
  tagLabel?: string;
  title?: string;
  oldValue?: string;
  newValue?: string;
  defaultValue?: string;
  smallFont?: boolean;
  ariaLabel?: string;
}

const MAX_VALUE_LENGTH = 25;
const MAX_TAG_LABEL_LENGTH = 30;

const truncate = (value: string, maxLength = MAX_VALUE_LENGTH): string =>
  value.length > maxLength ? `${value.slice(0, maxLength)}…` : value;

export const ActivityTagItem = ({
  tagLabel,
  title,
  oldValue,
  newValue,
  defaultValue,
  smallFont,
  ariaLabel = 'Change values',
}: ActivityTagItemProps) => {
  const classes = useStyles();

  return (
    <>
      {title && <Text color="secondary">{title}</Text>}
      <div
        className={classNames(classes.container, {
          [classes.smallFont]: smallFont,
        })}
      >
        {tagLabel && (
          <TagGroup aria-label={ariaLabel}>
            <Tag size="small">
              {truncate(upperFirst(tagLabel), MAX_TAG_LABEL_LENGTH)}
            </Tag>
          </TagGroup>
        )}
        {oldValue && (
          <span
            className={classNames(classes.value, classes.oldValue)}
            title={oldValue}
          >
            {truncate(oldValue)}
          </span>
        )}
        {newValue && (
          <span
            className={classNames(classes.value, classes.newValue)}
            title={newValue}
          >
            {truncate(newValue)}
          </span>
        )}
        {defaultValue && (
          <span className={classes.value} title={defaultValue}>
            {truncate(defaultValue)}
          </span>
        )}
      </div>
    </>
  );
};
